<div class="smart-bar" fxLayoutAlign="center center" fxLayoutGap="1%">
    <div class="smart-bar-icon">
        <img src="assets/images/ShiftAlerts.png" class="custom-icon" />
    </div>
    <span class="helping-text">Engage with your Internal Staff directly through their mobile devices and fill all your
        open shifts with
        <strong> Shift Alerts </strong> today.
    </span>
    <button mat-raised-button class="get-started-btn" (click)="openStaffPopup()">Get Started</button>
    <a (click)="hideSmartBanner.emit(true)">Not now</a>

</div>